import { Options } from 'devextreme/ui/pivot_grid/data_source';
import {
  bruttoEnergiaConfig,
  csucsterhelesConfig,
  elektromobilitasForgConfig,
  elektromobilitasTorzsConfig,
  eurostatEnergiamerlegConfig,
  evesBruttoVillanyConfig,
  evesFoldgazKulkerConfig,
  evesFoldgazMerlegConfig,
  evesHoTermelesConfig,
  evesHoMerlegConfig,
  evesMegujuloMerlegConfig,
  evesOlajKulkerConfig,
  evesOlajMerlegConfig,
  evesSzenKulkerConfig,
  evesSzenMerlegConfig,
  evesVillanyKulkerConfig,
  evesVillanyMerlegConfig,
  foldgazLakossagiArakConfig,
  foldgazNemLakossagiArakConfig,
  gazAtlagarConfig,
  gazElozetesNapiMerlegConfig,
  gazReszletesHaviMerlegConfig,
  haviBruttoVillanyConfig,
  haviFoldgazKulkerConfig,
  haviFoldgazMerlegConfig,
  haviOlajKulkerConfig,
  haviOlajKeszletConfig,
  haviOlajMerlegConfig,
  haviPrimerEnergiaConfig,
  haviSzenKulkerConfig,
  haviSzenMerlegConfig,
  haviVillanyKulkerConfig,
  haviVillanyMerlegConfig,
  haztartasVegsoConfig,
  iparVegsoConfig,
  kereskedelemVegsoConfig,
  kozlekedesVegsoConfig,
  kerSzolgHaviGazMerlegConfig,
  megujuloReszaranyConfig,
  IEAegyszerusitettConfig,
  IEAreszletesConfig,
  otvenMWConfig,
  rendszerHaviGazMerlegConfig,
  rendszerNapiGazMerlegConfig,
  termeloiTaroloiKihasznaltsagConfig,
  villamosKerSzolgConfig,
  villamosLakossagiArakConfig,
  villamosNemLakossagiArakConfig,
  villanyAtlagarConfig,
} from '../reports';

export interface Config {
  [reportId: string]: PivotGridConfig;
}

export interface FilterYearOptions {
  order?: 'asc' | 'desc';
  numberOfYears?: number;
}

export interface PivotGridConfig {
  title?: string;
  description?: string;
  details?: string;
  showChart?: boolean;
  filterYear?: FilterYearOptions;
  treeHeaderLayout?: boolean;
  options: Options;
}

export const pivotGridConfig: Config = {
  BruttoEnergia: bruttoEnergiaConfig,
  Csucsterheles: csucsterhelesConfig,
  ElektromobilitasForg: elektromobilitasForgConfig,
  ElektromobilitasTorzs: elektromobilitasTorzsConfig,
  GazAtlagar: gazAtlagarConfig,
  GazElozetesNapiMerleg: gazElozetesNapiMerlegConfig,
  GazReszletesHaviMerleg: gazReszletesHaviMerlegConfig,
  KerSzolgHaviGazMerleg: kerSzolgHaviGazMerlegConfig,
  OtvenMW: otvenMWConfig,
  RendszerHaviGazMerleg: rendszerHaviGazMerlegConfig,
  RendszerNapiGazMerleg: rendszerNapiGazMerlegConfig,
  TermeloiTaroloiKihasznaltsag: termeloiTaroloiKihasznaltsagConfig,
  VillamosKerSzolg: villamosKerSzolgConfig,
  VillanyAtlagar: villanyAtlagarConfig,

  EurostatEnergiamerleg: eurostatEnergiamerlegConfig,
  EvesBruttoVillany: evesBruttoVillanyConfig,
  EvesFoldgazKulker: evesFoldgazKulkerConfig,
  EvesFoldgazMerleg: evesFoldgazMerlegConfig,
  EvesHoTermeles: evesHoTermelesConfig,
  EvesHoMerleg: evesHoMerlegConfig,
  EvesMegujuloMerleg: evesMegujuloMerlegConfig,
  EvesOlajKulker: evesOlajKulkerConfig,
  EvesOlajMerleg: evesOlajMerlegConfig,
  EvesSzenKulker: evesSzenKulkerConfig,
  EvesSzenMerleg: evesSzenMerlegConfig,
  EvesVillanyKulker: evesVillanyKulkerConfig,
  EvesVillanyMerleg: evesVillanyMerlegConfig,
  FoldgazLakossagiArak: foldgazLakossagiArakConfig,
  FoldgazNemLakossagiArak: foldgazNemLakossagiArakConfig,
  HaviBruttoVillany: haviBruttoVillanyConfig,
  HaviFoldgazKulker: haviFoldgazKulkerConfig,
  HaviFoldgazMerleg: haviFoldgazMerlegConfig,
  HaviOlajKulker: haviOlajKulkerConfig,
  HaviOlajKeszlet: haviOlajKeszletConfig,
  HaviOlajMerleg: haviOlajMerlegConfig,
  HaviPrimerEnergia: haviPrimerEnergiaConfig,
  HaviSzenKulker: haviSzenKulkerConfig,
  HaviSzenMerleg: haviSzenMerlegConfig,
  HaviVillanyKulker: haviVillanyKulkerConfig,
  HaviVillanyMerleg: haviVillanyMerlegConfig,
  HaztartasVegso: haztartasVegsoConfig,
  IparVegso: iparVegsoConfig,
  KereskedelemVegso: kereskedelemVegsoConfig,
  KozlekedesVegso: kozlekedesVegsoConfig,
  MegujuloReszarany: megujuloReszaranyConfig,
  IEAegyszerusitett: IEAegyszerusitettConfig,
  IEAreszletes: IEAreszletesConfig,
  VillamosLakossagiArak: villamosLakossagiArakConfig,
  VillamosNemLakossagiArak: villamosNemLakossagiArakConfig,
};
